import { request } from './client';

export function fetchVideoMeta(videoId: string | number | undefined) {
  return request('GET', `/v1/account/media/videos/${videoId}`, { meta: 1 });
}
